import { useState } from 'react';

export const useClipboard = () => {
  const [copied, setCopied] = useState(false);

  const clipboardCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      // Reset after a short delay
      setTimeout(() => setCopied(false), 5000);
    } catch (err) {
      console.error('Failed to copy:', err);
      setCopied(false);
    }
  };

  return { copied, clipboardCopy };
};
